import MasterDetail from './MasterDetail.json';
import Coexistence from './Coexistence.json';
import Coexistence2 from './Coexistence2.json';

import demo1 from './demo1.json';
import demo2 from './demo2.json';
import demo3 from './demo3.json';
import demo4 from './demo4.json';

export default [MasterDetail, Coexistence, Coexistence2, demo1, demo2, demo3, demo4];
